module.exports = __webpack_public_path__ + "static/dave_250-96c824d6a4f809510d6e544a1f0f86a6.jpg";